import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const serEstarQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "¿Cuál es la forma correcta? 'Mi hermano ___ muy alto.'",
        options: ["es", "está", "son", "eran"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para características permanentes, como la altura de una persona."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Completa la oración: 'Hoy ___ muy cansado después de trabajar.'",
        options: ["soy", "es", "estoy", "estaré"],
        correctAnswerIndex: 2,
        explanation: "'Estar' se usa para estados temporales, como sentirse cansado en un momento específico."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "¿Cuál es la opción correcta? 'La conferencia ___ en Madrid.'",
        options: ["es", "está", "será", "fue"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para ubicaciones físicas, mientras que 'ser' se usaría si habláramos del evento en sí."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Selecciona la opción correcta: 'Mi hermano ___ médico.'",
        options: ["es", "está", "ha sido", "fuese"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para profesiones porque son consideradas características permanentes."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Elige la mejor opción: 'Hoy ___ muy cansado después de tanto trabajo.'",
        options: ["soy", "estoy", "he sido", "seré"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para describir estados de ánimo o físicos temporales."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "¿Cuál es la opción correcta? 'Madrid ___ en España.'",
        options: ["es", "está", "ha sido", "era"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para indicar ubicación geográfica."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Escoge la forma correcta del verbo: 'Esta comida ___ deliciosa.'",
        options: ["es", "está", "fue", "será"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para opiniones subjetivas y estados temporales de los alimentos."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Selecciona la mejor opción: 'El concierto ___ en el estadio central.'",
        options: ["es", "está", "ha sido", "era"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para indicar la ubicación de eventos."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Elige la opción correcta: 'Mis padres ___ de Argentina.'",
        options: ["son", "están", "fueron", "estuvieron"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para indicar nacionalidad u origen."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Completa la oración: 'No puedo hablar ahora, ___ ocupado.'",
        options: ["soy", "estoy", "he sido", "seré"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para estados temporales como estar ocupado en un momento específico."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "¿Cuál es la forma correcta? 'Este café ___ frío, ¿puedes calentarlo?'",
        options: ["es", "está", "ha sido", "era"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para describir estados temporales, como la temperatura de una bebida."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Selecciona la respuesta correcta: 'La reunión ___ en la oficina de Pedro.'",
        options: ["es", "está", "ha sido", "será"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para la ubicación de eventos y reuniones."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Elige la opción adecuada: 'Mi abuela ___ muy joven de espíritu.'",
        options: ["es", "está", "ha sido", "fue"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para cualidades de personalidad o esencia."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "¿Cuál es la respuesta correcta? 'Mi hermana ___ nerviosa porque tiene un examen.'",
        options: ["es", "está", "ha sido", "será"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para estados emocionales temporales."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Selecciona la mejor opción: 'Ese actor ___ muy guapo.'",
        options: ["está", "ha sido", "fue", "es"],
        correctAnswerIndex: 3,
        explanation: "'Ser' se usa para cualidades físicas permanentes."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Elige la forma correcta del verbo: 'La puerta ___ cerrada.'",
        options: ["es", "ha sido", "está", "será"],
        correctAnswerIndex: 2,
        explanation: "'Estar' se usa para describir estados físicos actuales."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Completa la frase correctamente: 'Estos zapatos ___ de cuero.'",
        options: ["son", "están", "fueron", "serán"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para describir materiales de los objetos."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Elige la mejor opción: 'Tú siempre ___ tan simpático con todos.'",
        options: ["eres", "estás", "has sido", "serás"],
        correctAnswerIndex: 0,
        explanation: "'Ser' se usa para rasgos de personalidad permanentes."
    },
    {
        category: QuizCategory.SER_VS_ESTAR,
        questionText: "Selecciona la opción correcta: 'Después del entrenamiento, nosotros ___ cansados.'",
        options: ["somos", "estamos", "fuimos", "seremos"],
        correctAnswerIndex: 1,
        explanation: "'Estar' se usa para estados físicos temporales."
    }
];

export default serEstarQuestions;
